import { reducer } from './reducer';
import { sagas } from './sagas';


export * from './actions';


export const monitoring = {
    reducer,
    sagas,
};
